import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import styles from "./Reason.module.scss";
import axiosClient from "../../service/axios";
import { SyncOutlined } from "@ant-design/icons";
import { adminToast, returnToast } from "../NotificationToast";

function PickRider({ rider, setRider, id, title, values }) {
  console.log("data", values);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({
    threePL: "",
    rider: "",
  });
  const [checked, setChecked] = useState(false);
  // console.log("values", values);
  const handleModalClose = () => {
    setRider(false);
  };

  useEffect(() => {
    const getRider = async () => {
      try {
        const response = await axiosClient.get(
          `/lite/v2/api/v3/start/return/${title}/${id}`
        );

        if (response.status === 200) {
          setData(response.data.data);
        }
      } catch (error) {
        console.log("Error in send to finance", error);
      }
    };

    if (values && id && title) {
      getRider();
    }
  }, [values, id, title]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };

  const handleSubmit = async () => {
    const payload = {
      flow: data.Key,
      selectedOptions,
      ...Object.entries(values).reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc[0];
      }, {}),
    };

    console.log(payload);
    try {
      setLoading(true);
      const response = await axiosClient.post(
        "/lite/v2/api/v3/return",
        payload
      );
      if (
        response.status === 200 &&
        (data.Key === "Flow 3" || data.Key === "Flow 5")
      ) {
        setLoading(false);
        adminToast();
        handleModalClose();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        setLoading(false);
        returnToast();
        handleModalClose();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <Dialog open={rider} onClose={handleModalClose}>
      <DialogContent style={{ paddingBottom: "0" }}>
        {data.Key === "Flow 3" ? (
          <>
            <div className={styles.title}>
              Core Hospitals - Flow 3
              <span>
                Intercity to a city where LifeBank is not (E.g., Edo to Lagos)
              </span>
            </div>
            <div className={styles.formContainer}>
              <div className={styles.formGroup}>
                <label htmlFor="threePL">3PL</label>

                <select
                  name="threePL"
                  id="threePL"
                  value={selectedOptions.threePL}
                  onChange={handleChange}
                >
                  <option value="">Select 3PL</option>
                  {data?.intercity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroup}>
                <label htmlFor=""> Rider</label>

                <select
                  name="rider"
                  id="rider"
                  value={selectedOptions.rider}
                  onChange={handleChange}
                >
                  <option value="rider">Select Rider</option>
                  {data?.intracity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={styles.formGroup}>
                <label htmlFor=""> Have you called the hospital?</label>
                <input
                  type="checkbox"
                  name="options"
                  id="options"
                  checked={checked}
                  onChange={handleCheck}
                />
              </div>
            </div>
          </>
        ) : data.Key === "Flow 5" ? (
          <>
            <div className={styles.title}>
              Core Hospitals - Flow 5
              <span>
                Intercity LifeBank is neither at the city of the vendor nor the
                hospital (E.g., Aba to Onitsha)
              </span>
            </div>
            <div className={styles.formContainer}>
              <div className={styles.formGroup}>
                <label htmlFor="threePL">3PL</label>

                <select
                  name="threePL"
                  id="threePL"
                  value={selectedOptions.threePL}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select 3PL
                  </option>
                  {data?.intercity?.map((item) => (
                    <option key={item.id} value={item.dispatch_name}>
                      {item.dispatch_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={styles.formCheck}>
                <label htmlFor=""> Have you called the hospital?</label>
                <input
                  type="checkbox"
                  name="options"
                  id="options"
                  checked={checked}
                  onChange={handleCheck}
                />
              </div>
            </div>
          </>
        ) : null}
      </DialogContent>
      <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
        <button
          style={{
            cursor: "pointer",
            color: "#ffffff",
            backgroundColor: checked ? "#b70303" : "#dfdfdf",
            padding: "10px",
            borderRadius: "3px",
            border: "1px solid #DFE1E6",
            fontSize: "14px",
          }}
          onClick={handleSubmit}
          disabled={!checked}
        >
          {loading ? <SyncOutlined Spin /> : "Return"}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default PickRider;
